// for a legacy code and future fixes
module.exports = function () {
  return Function.call.apply(Array.prototype.reverse, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/reverse.js
// module id = 746
// module chunks = 0